import React, {useEffect, useState} from 'react';
import {formatSimmsDateTimeKorean} from "../commonmethod/CommonMethod";

function ReadOnlyInputValue({data, target, value, type}) {
    const [textValue, setTextValue] = useState("");

    useEffect(() => {
        data.setData(prev => ({
            ...prev,
            [target]: value,
        }));
        setTextValue(handleSetValue(value && value.name? value.name : value));
    }, []);

    const handleSetValue = (value) => {
        let valued
        if(type==="date") {
            valued = value ? formatSimmsDateTimeKorean(value) : "";
        } else if (!value) {
            valued = ""
        } else {
            valued = value;
        }
        return valued;
    }

    return (

        <input
            type={"text"}
            className={"read-only-input cursor-default"}
            value={textValue}
            readOnly={true}
        />
    );
}

export default ReadOnlyInputValue;